import { AssignmentPriority, AssignmentStatus } from '@/types';

export const getStatusColor = (status: AssignmentStatus) => {
  const colors: Record<AssignmentStatus, string> = {
    created: 'bg-blue-100 text-blue-800',
    briefing_prepared: 'bg-yellow-100 text-yellow-800',
    interview_scheduled: 'bg-purple-100 text-purple-800',
    interview_in_progress: 'bg-orange-100 text-orange-800',
    interview_completed: 'bg-green-100 text-green-800',
    transcript_ready: 'bg-indigo-100 text-indigo-800',
    draft_generated: 'bg-pink-100 text-pink-800',
    under_review: 'bg-amber-100 text-amber-800',
    approved: 'bg-emerald-100 text-emerald-800',
    published: 'bg-gray-100 text-gray-800',
    cancelled: 'bg-red-100 text-red-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const getPriorityColor = (priority: AssignmentPriority) => {
  const colors = {
    low: 'bg-green-100 text-green-800',
    medium: 'bg-yellow-100 text-yellow-800',
    high: 'bg-orange-100 text-orange-800',
    urgent: 'bg-red-100 text-red-800',
  };
  return colors[priority];
};
